import React, { useState } from "react";
import styled from "styled-components";
import * as Yup from "yup";
import { Theme } from "@literati/public-ui-shared-react";
import LegacyThemeProvider from "components/Layout/DefaultThemeProvider";
import { Subscription } from "lib/api/subscription";
import StepLayout, { StepLayoutProps } from "components/Step/StepLayout";
import {
  getContentfulQuizStep,
  gsuSubmitAnswersDefault,
} from "components/Step/stepUtil";
import {
  GenderSubmit,
  GenderValues,
  GenderValuesPartial,
  GenderKey as Key,
} from "components/Step/stepTypes";
import GuidedSignUpLayoutRadio from "components/GuidedSignUp/GuidedSignUpLayoutRadio";

export const VALIDATION_SCHEMA = Yup.object().shape({
  [Key.GENDER]: Yup.string().required("Required."),
});

export const INITIAL_VALUES: GenderValues = {
  [Key.KIND]: "gender",
  [Key.GENDER]: "",
} as const;

export function getReadingLevelStep(contentfulQuizModel?: any) {
  const step = getContentfulQuizStep(contentfulQuizModel, "reader-gender");
  return step;
}

const StyledGuidedSignUpLayoutRadio = styled(GuidedSignUpLayoutRadio)`
  padding: 2rem 0;
`;

export type StepLayoutPropsGender = Omit<
  StepLayoutProps<GenderValues>,
  "asForm" | "children" | "formId"
>;

export interface StepGenderProps extends StepLayoutPropsGender {
  childName?: string;
  contentfulQuizModelParsed?: any;
  initialValues?: GenderValuesPartial;
  onSubmit: GenderSubmit;
  subscription?: Subscription;
}

export const StepGender = ({
  childName,
  contentfulQuizModelParsed,
  onSubmit,
  initialValues: initialValuesProp,
  subscription,
  ...stepLayoutProps
}: StepGenderProps) => {
  const [initialValues] = useState<GenderValues>({
    ...INITIAL_VALUES,
    ...initialValuesProp,
  });

  const [step] = useState(getReadingLevelStep(contentfulQuizModelParsed));

  const handleSubmit: GenderSubmit = async (values, formikHelpers) => {
    return await gsuSubmitAnswersDefault({
      contentfulQuizModel: contentfulQuizModelParsed,
      formikHelpers,
      onError: (res) => res, // @TODO
      onSubmit,
      step,
      subscription,
      values,
    });
  };

  return (
    <Theme>
      <StepLayout<GenderValues>
        asForm
        bgColor="white"
        formId="activation-step-gender"
        formikProps={{
          initialValues,
          onSubmit: handleSubmit,
          validationSchema: VALIDATION_SCHEMA,
        }}
        {...stepLayoutProps}
      >
        <LegacyThemeProvider>
          <StyledGuidedSignUpLayoutRadio step={step} childName={childName} />
        </LegacyThemeProvider>
      </StepLayout>
    </Theme>
  );
};

export default StepGender;
